/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { TraceabilityRequestContactResponseDto } from "./TraceabilityRequestContactResponseDto.ts"

export const traceabilityRequestResponseDtoStatusEnum = {
  OPENED: "OPENED",
  CLOSED: "CLOSED",
  CANCELED: "CANCELED",
} as const

export type TraceabilityRequestResponseDtoStatusEnumKey =
  (typeof traceabilityRequestResponseDtoStatusEnum)[keyof typeof traceabilityRequestResponseDtoStatusEnum]

export const traceabilityRequestResponseDtoPersistedStatusEnum = {
  OPENED: "OPENED",
  CLOSED: "CLOSED",
  CANCELED: "CANCELED",
} as const

export type TraceabilityRequestResponseDtoPersistedStatusEnumKey =
  (typeof traceabilityRequestResponseDtoPersistedStatusEnum)[keyof typeof traceabilityRequestResponseDtoPersistedStatusEnum]

export type TraceabilityRequestResponseDto = {
  /**
   * @type number
   */
  id: number
  /**
   * @type object
   */
  item: object
  /**
   * @type string
   */
  activityId: string
  /**
   * @type string
   */
  activityName: string
  /**
   * @type object
   */
  issuer: object
  /**
   * @type string
   */
  status: TraceabilityRequestResponseDtoStatusEnumKey
  /**
   * @type string
   */
  persistedStatus: TraceabilityRequestResponseDtoPersistedStatusEnumKey
  /**
   * @type number | undefined
   */
  productId?: number
  /**
   * @type string | undefined
   */
  productUuid?: string
  /**
   * @type string | undefined
   */
  productName?: string
  /**
   * @type array
   */
  customFieldDefinitions: object[]
  /**
   * @type string
   */
  contactId: string
  /**
   * @type object
   */
  contact: TraceabilityRequestContactResponseDto
  /**
   * @type boolean
   */
  reinforcedTraceability: boolean
  /**
   * @type string, date-time
   */
  createdAt: Date
}
